export default __webpack_public_path__ + "static/media/material-paper.8b57a6b1.svg";